import { graphql } from "../gql";

export const deleteAskAutodorQueueMutationDoc = graphql(`
  mutation deleteAskAutodorQueue($id: ID!) {
    deleteAskAutodorQueue(id: $id) {
      ...AskAutodorQueueFragment
    }
  }
`);
